module.exports = {
  "country": "AT",
  "artist": "Teya & Salena ",
  "song": "Who the Hell is Edgar?",
  "year": "2023",
  "place": "15",
  "spotify": "3gUC7tGDPVLOq42vvTUVdI"
};